import Block from '../blots/block';

class Blockquote extends Block {
  static blotName = 'blockquote';
  static tagName = 'blockquote';
}

export default Blockquote;
